module.exports = __webpack_public_path__ + "static/media/ID.651d2ea5.png";